import request from '@/utils/request';

export function login(account,psw) {
    return request({
        url: '/edas/login',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
          account : account,
          psw : psw
        }
    })
}

export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js